<template>
    <header class="header">
        <div class="header-detalis">
            <div class="container-fluid">
                <div class="header-title">
                    <div class="me-2">
                        <template v-if="user_role == 1">
                            <a href="/backend/list/newsannouncements">
                                <img class="header-img" src="/static/images/vtc-icon.png" alt="">
                            </a>
                        </template>
                        <template v-else>
                            <a href="/">
                                <img class="header-img" src="/static/images/vtc-icon.png" alt="">
                            </a>
                        </template>
                    </div>
                    <div class="compliance-info">
                        <span class="header-title">WELCOME TO THE</span>
                        <h1 class="sub-title">COMPLIANCE & ETHICS PORTAL</h1>
                        <p class="header-content">On VVG’s internal compliance and ethics portal, we hope to guide and empower our employees to uphold the highest standards of compliance and ethics. We encourage you to navigate through the resources and materials provided to enhance your understanding and commitment to our company's values. This portal serves as a central hub for information sharing and promoting a culture of accountability within our organization. Together, we can uphold the commitment to compliance, ethics, and integrity that defines us and ensures our continued success.</p>
                    </div>
                    <div class="ms-2">
                        <img class="header-img" src="/static/images/compliance-icon.png" alt="">
                    </div>
                    <div class="">
                        <div class="hamburger-logo">
                            <a id="search-logo" class="fa fa-search search-logo" data-bs-toggle="tooltip" data-bs-placement="bottom"></a>
                            <div class="serch-textaera">
                                <i class="fa fa-search search-logo"></i>
                                <input type="text" placeholder="search" class="text-boxarea">
                                <i class="fa fa-times" id="close-textaera"></i>
                            </div>
                            <i class="fa fa-bars hamburger-menu"></i>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="header-menu">
            <div class="container">
                <div class="main-menu">
                    <div class="">
                        <a href="/ondemandtrainings">ON-DEMAND TRAINING</a>
                    </div>
                    <div class="">
                        <a href='/policies'>POLICIES</a>
                    </div>
                    <div class="">
                        <a href="javascript:void(0)" @click.prevent="loadCodeofConduct">
                            CODE OF BUSINESS ETHICS
                        </a>
                    </div>
                    <div class="">
                        <a href="/projects">PROJECTS</a>
                    </div>
                    <div class="">
                        <a target="_blank" href="https://secure.ethicspoint.com/domain/media/en/gui/92280/index.html">SPEAK UP LINE</a>
                    </div>
                    <div class="search-box">
                        <input type="text" class="form-control text-box" v-model="search" @keydown.enter="triggerSearch" ref="searchInput">
                        <a :href="search ? searchUrl : 'javascript:void(0)'" @click.prevent="handleSearchClick">
                            SEARCH
                        </a>
                    </div>
                    <div class="">
                        <a href="javascript:void(0)" v-on:click.prevent="logout">LOGOUT</a>
                        <!-- <i class="fa fa-sign-out" @click.prevent="logout"></i> -->
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

    import Vue from 'vue';
    import eventBus from '../event-bus';
    import { HTTP } from '../../http-common';
    var contex;
    import {commonMixins} from '../../mixins/commonMixins';
    import Swal from 'sweetalert2';

    export default {
        name: "Header",
        mixins: [commonMixins],
        data: () => ({
                profileColor: "",
                isShowLoggedinfields: false,
                loggedin_user_img: '',
                loggedin_user: '',
                loggedin_user_last_name: '',
                role: "",
                username: "",
                image: "/static/images/default.jpg",
                search: "",
                user_role: localStorage.getItem("user_role"),
                user_country_id: 0,
            }),
        computed: {
            searchUrl() {
                return `/search/${encodeURIComponent(this.search)}`;
            },
            shouldRedirect() {
                return this.$route.path.startsWith('/backend');
            }
        },
        beforeMount: function () {
            contex = this;
        },
        created: function () {
            var self = this;
            var userObjString = localStorage.getItem('user_obj');
            if (userObjString) {
                var userObj = JSON.parse(userObjString);
                self.user_country_id = userObj.country_id;
            }
        },
        mounted: function () {
            var self = this;
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var profileColor = localStorage.getItem('profileColor');
                if (profileColor && profileColor != null) {
                    self.profileColor = profileColor;
                } else {
                    self.profileColor = self.gerRandomColor();
                    localStorage.setItem("profileColor", self.profileColor);
                }
                if (self.profileColor != "") {
                    /*$(".username-letter").css({"background": self.profileColor});*/
                }
                var userJson = JSON.parse(userObj);
                self.loggedin_user = self.formatString(userJson["first_name"]);
                self.loggedin_user_last_name = self.formatString(userJson["last_name"]);
                self.loggedin_user_img = (self.loggedin_user.charAt(0) + self.loggedin_user_last_name.charAt(0)).toUpperCase();
                self.username = self.formatString(userJson["username"]);
                if (self.loggedin_user_img == "") {
                    self.loggedin_user_img = (self.username.charAt(0) + self.username.charAt(1)).toUpperCase();
                }

            }
            //self.$store.dispatch('getRole');
        },
        methods: {
            triggerSearch() {
                if(this.search) {
                    window.location.href = this.searchUrl;
                }
            },

            handleSearchClick() {
                if (!this.search) {
                    this.$refs.searchInput.focus(); // Set focus to the input if search is empty
                } else {
                    this.triggerSearch(); // Trigger search if there's a value
                }
            },

            logout: function () {
                this.showLoader();
                //clear all local storage
                localStorage.clear();
                window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                // window.location.href = "/";
                //contex.$router.push("/");
            },

            formatString: function (data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp.toUpperCase();
            },

            loadCodeofConduct: async function () {
                var self = this;

                var config = {
                    headers: { 'Authorization': 'Bearer ' + localStorage.getItem("tkn") },
                    params: {
                        'slug': 'code-of-conduct',
                        'user_country_id': self.user_country_id,
                    }
                };
                self.showLoader();
                return HTTP.post("documents/list", {}, config)
                    .then(async function (response) {
                        if (response.data.code == '200') {
                            const row = response.data.content.row ? response.data.content.row[0] : [];
                            if (row) {
                                if (row.upload_type === 'url') {
                                    self.codeOfConduct = row.url;
                                } else if (row.documents && row.documents[0]) {
                                    self.codeOfConduct = row.documents[0].document;
                                    console.log(self.codeOfConduct);
                                }
                            }
                        }
                        self.hideLoader();
                        if(self.codeOfConduct) {
                            window.open(self.codeOfConduct, '_blank', 'noopener noreferrer');
                            self.codeOfConduct = null;
                        } else {
                            Swal.fire({
                                title: 'Important Announcement!',
                                type: 'info',
                                text: 'Stay tuned! Code of Conduct document will be available soon.',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                customClass: 'code-of-conduct-model'
                            });
                        }
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () { });
                        return null;
                    });
            },

        },

    };

    eventBus.$on('logged-in', function (isLogin, name, lastName, username) {
        contex.isShowLoggedinfields = isLogin;
        contex.loggedin_user = name.trim();
        contex.loggedin_user_last_name = lastName.trim();
        contex.loggedin_user_img = (contex.loggedin_user.charAt(0) + contex.loggedin_user_last_name.charAt(0)).toUpperCase();
        contex.username = username;
        if (contex.loggedin_user_img == "") {
            contex.loggedin_user_img = (contex.username.charAt(0) + contex.username.charAt(1)).toUpperCase();
        }
        //contex.role = role;
        //contex.image = "/static/images/default.jpg";

        /* if (file_path != null){
         contex.image = file_path;
         }else{
         contex.image = "/static/images/default.jpg";
         } */

    });

    $(document).ready(function(){
        $(".hamburger-menu").click(function(){
            $(".header-menu").slideToggle();
        });
    });

    $(document).ready(function(){
        $("#search-logo").click(function(){
            $(".serch-textaera").show();
        });
        $("#close-textaera").click(function(){
            $(".serch-textaera").hide();
        });
    });

</script>



// WEBPACK FOOTER //
// src/components/partials/Header.vue